<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
          <div class="p-formgrid p-grid p-col">
            <div v-if="checkPermission()" class="p-col-12 p-lg-6 p-mt-2">
              <div class="p-formgrid p-grid">
                <div class="p-field p-col-10 p-lg-10">
                  <label class="p-mr-2">สังกัด</label>
                  <Button
                    @click="showOrganize = true"
                    icon="pi pi-plus"
                    class="p-button-success"
                    ref="TextBox_1_search"
                    @keyup.left="moveFocus($event, 'TextBox_4_search','Button')"
                    @keyup.right="moveFocus($event, 'TextBox_2_search','Input')"
                    @keyup.down="moveFocus($event, 'TextBox_3_search','Button')"
                  />
                </div>
              </div>
              <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                <DataTable
                  :value="organize_table"
                  :scrollable="true"
                  scrollHeight="500px"
                  :paginator="true"
                  :rows="3"
                  dataKey="id"
                  :rowHover="true"
                  :selection.sync="selectedOrganizeData"
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                >
                  <template #empty>{{ $t("TableEmpty") }}</template>
                  <Column
                    field="organize_name"
                    :header="$t('id_operating_name')"
                    :sortable="true"
                    headerStyle="width: 20rem"
                  >
                    <template #body="dataTable">
                      <div hidden>{{ dataTable.data.organize_id }}</div>
                      {{ dataTable.data.organize_name }}
                    </template>
                  </Column>
                  <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                    <template #body="dataTable">
                      <div class="p-formgrid p-grid">
                        <div class="p-field p-col-6">
                          <Button
                            @click="
                              // displayConfirmation = true;
                              deleteTable = 'organize';
                              organizeDelete = dataTable.data;
                              alertDisplay(organizeDelete, deleteTable);
                            "
                            icon="pi pi-trash"
                            :label="$t('deleteBtn')"
                            class="p-button-rounded p-button-danger"
                          />
                        </div>
                      </div>
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>

            <div :class="styleClassHeader.divHead">
              <div :class="styleClassHeader.divBody">
                <label for="permissionOptions">{{ $t("level") }}</label>
                <Dropdown
                  v-model="permissionSelect"
                  :options="permissionOptions"
                  optionLabel="permission_name"
                  :filter="true"
                  :placeholder="$t('placeholderSelectBox')"
                  :showClear="true"
                  :clearFilterDropdown="dropdownClearFilerValue"
                >
                  <template #value="permissionOptions">
                    <div v-if="permissionOptions.value">
                      <div>{{ permissionOptions.value.permission_name }}</div>
                    </div>
                    <span v-else>
                      {{ permissionOptions.placeholder }}
                    </span>
                  </template>
                  <template #option="permissionOptions">
                    <div>{{ permissionOptions.option.permission_name }}</div>
                  </template>
                </Dropdown>
              </div>
              <div :class="styleClassHeader.divBody">
                <label for="keyword">{{ $t("keyword") }}</label>
                <InputText 
                  id="system_keyword" 
                  type="text" 
                  v-model="keyword" 
                  ref="TextBox_2_search"
                  @keyup.left="moveFocus($event, 'TextBox_1_search','Button')"
                  @keyup.right="moveFocus($event, 'TextBox_3_search','Button')"
                  @keyup.up="moveFocus($event, 'TextBox_1_search','Button')"
                  @keyup.down="moveFocus($event, 'TextBox_3_search','Button')"
                />
              </div>

              <div class="p-field p-col">
                <div class="p-formgrid p-grid p-jc-end p-mt-5">
                  <Button
                    @click="clearSearchField()"
                    :label="$t('clearBtn')"
                    class="p-button-clear p-ml-3 p-mr-3"
                    ref="TextBox_3_search"
                    @keyup.left="moveFocus($event, 'TextBox_2_search','Input')"
                    @keyup.right="moveFocus($event, 'TextBox_4_search','Button')"
                    @keyup.up="moveFocus($event, 'TextBox_2_search','Button')"
                  />
                  <Button
                    @click="searchSystemUser()"
                    :label="$t('searchBtn')"
                    class="p-button-info"
                    ref="TextBox_4_search"
                    @keyup.left="moveFocus($event, 'TextBox_3_search','Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_search','Button')"
                    @keyup.up="moveFocus($event, 'TextBox_2_search','Button')"
                  />
                </div>
              </div>

            </div>
          </div>

          <div class="p-formgrid p-grid p-col p-mt-1">
              <text-footer
                :data="Data_text_Footer"
                :checkShow="text_Footer"
                :countItem="systemUser_table.length.toLocaleString('en-US')"
              />
          </div>
      </div>
    </Fieldset>

    <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"
      :visible.sync="showOrganize"
      :style="{ width: '80%' }"
    >
      <organize-table
        @selectOrganization="selectedOrganize_passValue"
        :parentmessage="parentmessage_organize"
      ></organize-table>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"  
      :visible.sync="showOrganize_Form"
      :style="{ width: '80%' }"
    >
      <organize-form
        @selectOrganization="selectedOrganize_passValue_Form"  
      ></organize-form>
    </Dialog>

    <div class="card p-fluid p-mt-2">
      <DataTable
        :value="systemUser_table"
        scrollHeight="500px"
        :paginator="true"
        :rows="10"
        sortField="user_username"
        :sortOrder="1"
        dataKey="id"
        :rowHover="true"
        :selection.sync="selectedSystemUser"
        :filters="filters"
        :loading="loading"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #header>
          <div class="p-grid">
            <div class="table-header p-col-12 lg-1 " style="padding: 7px;  " id="Create" v-if="checkAdd_data != 'false'">
              <Button
                @click="systemUserModal = true"
                :label="$t('addBtn')"
                class="p-button-success"
              />
            </div>
            <div class="table-header  p-col-12 p-lg-3"  id="Search" style="margin-left: auto">
              <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span>
            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>
        <Column
          field="user_username"
          :header="$t('isu_username')"
          :sortable="true"
          :headerStyle="tableColSticky('10rem','','sticky','top')"
        >
          <template #body="dataTable">
            <div hidden>{{ dataTable.data.user_id }}</div>
            {{ dataTable.data.user_username }}
          </template>
        </Column>
        <Column
          field="user_fullname"
          :header="$t('isu_fullname')"
          :sortable="true"
          :headerStyle="tableColSticky('14rem','','sticky','top')"
        >
          <template #body="dataTable">
            {{ dataTable.data.user_fullname }}
          </template>
        </Column>

        <Column
          field="permission_name"
          :header="$t('isu_userlevel')"
          :sortable="true"
          :headerStyle="tableColSticky('12rem','','sticky','top')"
        >
          <template #body="dataTable">
            {{ dataTable.data.permission_name }}
          </template>
        </Column>

        <!--  -->
        <Column
          field="view_data"
          :header="'สิทธิ์ดูข้อมูล'"
          :sortable="true"
          :headerStyle="tableColSticky('12rem','center','sticky','top')"
        >
          <template #body="dataTable">
            <!-- {{ dataTable.data.view_data == 'true' ? '✅ มีสิทธิ์' : '❌ ไม่มีสิทธิ์' }} -->
            <div class="table_row">
              <span :class="'customer-badge status-' + dataTable.data.view_data">{{ dataTable.data.view_data == 'true' ? ' มีสิทธิ์' : ' ไม่มีสิทธิ์' }}</span>
            </div>
            
       
          </template>
        </Column>

        <Column
          field="add_data"
          :header="'สิทธิ์เพิ่มข้อมูล'"
          :sortable="true"
          :headerStyle="tableColSticky('14rem','center','sticky','top')"
        >
          <template #body="dataTable">
            <!-- {{ dataTable.data.add_data == 'true' ? '✅ มีสิทธิ์' : '❌ ไม่มีสิทธิ์'}} -->
            <div class="table_row">
              <span :class="'customer-badge status-' + dataTable.data.add_data">{{ dataTable.data.add_data == 'true' ? ' มีสิทธิ์' : ' ไม่มีสิทธิ์' }}</span>
            </div>
            

          </template>
        </Column>

        <Column
          field="edit_data"
          :header="'สิทธิ์แก้ไขข้อมูล'"
          :sortable="true"
          :headerStyle="tableColSticky('14rem','center','sticky','top')"
        >
          <template #body="dataTable">
            <!-- {{ dataTable.data.edit_data == 'true' ? '✅ มีสิทธิ์' : '❌ ไม่มีสิทธิ์'}} -->
            <div class="table_row">
              <span :class="'customer-badge status-' + dataTable.data.edit_data">{{ dataTable.data.edit_data == 'true' ? ' มีสิทธิ์' : ' ไม่มีสิทธิ์' }}</span>
            </div>
            

          </template>
        </Column>

        <Column
          field="delete_data"
          :header="'สิทธิ์ลบข้อมูล'"
          :sortable="true"
          :headerStyle="tableColSticky('13rem','center','sticky','top')"
        >
          <template #body="dataTable">
            <!-- {{ dataTable.data.delete_data == 'true' ? '✅ มีสิทธิ์' : '❌ ไม่มีสิทธิ์' }} -->
            <div class="table_row">
              <span :class="'customer-badge status-' + dataTable.data.delete_data">{{ dataTable.data.delete_data == 'true' ? ' มีสิทธิ์' : ' ไม่มีสิทธิ์' }}</span>
            </div>
            

          </template>
        </Column>
<!--  -->
        <Column
          field="organize_name"
          :header="$t('isu_organize')"
          :sortable="true"
          :headerStyle="tableColSticky('20rem','','sticky','top')"
        >
          <template #body="dataTable">
            {{ dataTable.data.organize_name }}
          </template>
        </Column>

          <Column
            field="date_create_ddmmyy"
            :header="'วันที่สร้างข้อมูล'"
            :sortable="true"
            :headerStyle="tableColSticky('15rem','','sticky','top')"
          >
            <template #body="dataTable">
              
                {{ dataTable.data.date_create_ddmmyy }}
              
            </template>
          </Column>

          <Column
            field="date_update_ddmmyy"
            :header="'วันที่ปรับปรุงข้อมูล'"
            :sortable="true"
            :headerStyle="tableColSticky('15rem','','sticky','top')"
          >
            <template #body="dataTable">
              
                {{ dataTable.data.date_update_ddmmyy }}
            
            </template>
          </Column>

        <Column :header="$t('controlTable')" 
        :headerStyle="table_headerStyle"    
        :bodyStyle="table_bodyStyle"
        v-if="checkEdit_data != 'false' || checkDelete_data != 'false' ">
          <template #body="dataTable">
            <div class="p-formgrid col_manege" v-if="checkNotAdminPermission(dataTable.data.user_organize)">
              <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                <Button
                  @click="
                    systemUserModal = true;
                    editData(dataTable.data.user_id);
                    temp = dataTable.data.user_id;
                  "
                  icon="pi pi-pencil"
                  :label="table_editBTN"
                  class="p-button-rounded p-button-warning"
                />
              </div>
              <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                <Button
                  @click="
                    // displayConfirmation = true;
                    temp = dataTable.data.user_id;
                    deleteTable = ''
                    alertDisplay(temp,deleteTable);
                  "
                  icon="pi pi-trash"
                  :label="table_deleteBTN"
                  class="p-button-rounded p-button-danger"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
    <!-- :contentStyle="{ 'overflow-y': 'scroll' }" -->
    <!-- Manage data -->
    <Dialog
      :modal="true"
      :visible.sync="systemUserModal"
      :style="{ width: '700px' }"
      
      :header="header"
    >
      <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
        <label>{{ $t("isu_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          <div class="p-formgrid p-grid">
            <div class="p-field p-col-8 p-lg-10 p-mt-2" >
              <label for="isu_organize"
                >{{ $t("isu_organize") }}
                <span class="required-input">*</span></label
              >
              <InputText
                id="isu_organize"
                type="text"
                v-model="isu_organize.name"
                disabled
                :class="{
                  'p-invalid': error_isu_organize && !isu_organize.name,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_isu_organize && !isu_organize.name"
                >{{ $t("isu_organize_validate") }}</small
              >
            </div>
            <div class="p-field p-col-4 p-lg-2">
              <div>
                <Button
                  @click="showOrganize_Form = true"
                  icon="pi pi-ellipsis-h"
                  class="p-button-secondary p-mt-5 p-mr-2"
                  autofocus
                  ref="TextBox_1"
                  @keyup.left="moveFocus($event, 'TextBox_7','Button')"
                  @keyup.right="moveFocus($event, 'TextBox_2','Button')"
                  @keyup.down="moveFocus($event, 'TextBox_3','Input')"
                />
                <Button
                  @click="isu_organize = {}"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-5"
                  ref="TextBox_2"
                  @keyup.left="moveFocus($event, 'TextBox_1','Button')"
                  @keyup.right="moveFocus($event, 'TextBox_3','Input')"
                  @keyup.down="moveFocus($event, 'TextBox_3','Input')"
                />
              </div>
            </div>
          </div>

          <div class="p-formgrid p-grid p-mt-3">
            <div class="p-field p-col-12 p-lg-12">
              <label for="isu_fullname"
                >{{ $t("isu_fullname") }}
                <span class="required-input">*</span></label
              >
              <InputText
                id="isu_fullname"
                type="text"
                v-model="isu_fullname"
                required="true"
                :class="{ 'p-invalid': error_isu_fullname && !isu_fullname }"
                ref="TextBox_3"
                @keyup.left="moveFocus($event, 'TextBox_2','Button')"
                @keyup.right="moveFocus($event, 'TextBox_4','Input')"
                @keyup.up="moveFocus($event, 'TextBox_1','Button')"
                @keyup.down="moveFocus($event, 'TextBox_4','Input')"
              />
              <small
                class="p-invalid"
                v-if="error_isu_fullname && !isu_fullname"
                >{{ $t("isu_fullname_validate") }}</small
              >
            </div>
          </div>

          <div class="p-formgrid p-grid p-mt-3">
            <div class="p-field p-col-12 p-lg-6">
              <label for="isu_username"
                >{{ $t("isu_username") }}
                <span class="required-input">*</span></label
              >
              <InputText
                id="isu_username"
                type="text"
                v-model="isu_username"
                @input="checkChar()"
                required="true"
                :class="{ 'p-invalid': error_isu_username && !isu_username }"
                ref="TextBox_4"
                @keyup.left="moveFocus($event, 'TextBox_3','Input')"
                @keyup.right="moveFocus($event, 
                isDisabledPassword !== 1 ? 'TextBox_5' :'TextBox_6',
                isDisabledPassword !== 1 ? 'Input' : 'Button')"
                @keyup.up="moveFocus($event, 'TextBox_3','Input')"
                @keyup.down="moveFocus($event, 'TextBox_6','Input')"
              />
              <small
                class="p-invalid"
                v-if="error_isu_username && !isu_username"
                >{{ $t("isu_username_validate") }}</small
              >
            </div>

            <div class="p-field p-col-12 p-lg-6">
              <label for="isu_password"
                >{{ $t("isu_password") }}
                <span class="required-input">*</span></label
              >
              <InputText
                :disabled="isDisabledPassword == 1"
                id="isu_password"
                @input="checkChar()"
                :type="type"
                v-model="isu_password"
                required="true"
                :class="{ 'p-invalid': error_isu_password && !isu_password }"
                ref="TextBox_5"
                @keyup.left="moveFocus($event, 'TextBox_4','Input')"
                @keyup.right="moveFocus($event, 'TextBox_6','Button')"
                @keyup.up="moveFocus($event, 'TextBox_3','Input')"
                @keyup.down="moveFocus($event, 'TextBox_6','Input')"
              />
              <small
                class="p-invalid"
                v-if="error_isu_password && !isu_password"
                >{{ $t("isu_password_validate") }}</small
              >
            </div>
          </div>

          <div class="p-formgrid p-grid p-mt-3">
            <div class="p-field p-col-12 p-lg-6 p-mt-3">
              <label for="permissionOptions"
                >{{ $t("level") }} <span class="required-input">*</span></label
              >
              <Dropdown
                v-model="isu_level_select"
                :options="permissionOptions"
                optionLabel="permission_name"
                :class="{
                  'p-invalid': error_isu_level_select && !isu_level_select,
                }"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="permissionOptions">
                  <div v-if="permissionOptions.value">
                    <div>{{ permissionOptions.value.permission_name }}</div>
                  </div>
                  <span v-else>
                    {{ permissionOptions.placeholder }}
                  </span>
                </template>
                <template #option="permissionOptions">
                  <div>{{ permissionOptions.option.permission_name }}</div>
                </template>
              </Dropdown>
              <small
                class="p-invalid"
                v-if="error_isu_level_select && !isu_level_select"
                >{{ $t("isu_permission_validate") }}</small
              >
            </div>
            <div class="p-field p-col-12 p-lg-6 p-mt-3">
              <div class="p-field-checkbox">
                <Checkbox
                  id="isu_password_generate"
                  name="isu_password_generate"
                  value="1"
                  v-model="isu_password_generate"
                  :disabled="disabledGenPassword"
                />
                <label for="isu_password_generate">{{
                  $t("isu_password_generate")
                }}</label>
              </div>
              <div class="p-field-checkbox" v-if="selectedData != ''">
                <p
                  @click="
                    type = 'text';
                    isDisabledPassword = 0;
                    disabledGenPassword = false;
                  "
                  class="pointer"
                  id="isu_password_reset"
                >
                  <u>{{ $t("isu_password_reset") }}</u>
                </p>
              </div>
            </div>

            <!-- ส่วนจัดการข้อมูล -->
            <div class="p-field p-col-12 p-lg-12 p-mt-4">
              <label for="isu_organize"
                >{{ 'ส่วนจัดการข้อมูล ' }}<span class="required-input">*</span>
            </label>
            </div>
            
              
            <!-- 'View data' -->
            <div class="p-field p-col-12 p-lg-3 p-mt-3">

              <div class="field-checkbox" >
                <!-- <Checkbox inputId="binary_View_data" v-model="checkedBox_View_data" :binary="false" v-if="checkedBox_View_data == false || checkedBox_View_data == 'false' "/> -->
                <!-- <Checkbox inputId="binary_View_data" v-model="checkedBox_View_data" :binary="true" v-else/> -->
                <Checkbox inputId="binary_View_data" v-model="checkedBox_View_data" value=true  :disabled="true"/>
                <!-- <label for="binary_View_data"> View Data  : {{checkedBox_View_data}}</label> -->
                <label for="binary_View_data"> สิทธิ์ดูข้อมูล</label>
              </div>

           
              

            </div>
            <!-- Add data -->
            <div class="p-field p-col-12 p-lg-3 p-mt-3">
              <div class="field-checkbox" >
                <!-- <Checkbox inputId="binary_Add_data" v-model="checkedBox_Add_data" :binary="false"  v-if="checkedBox_Add_data == false || checkedBox_Add_data == 'false'"/> -->
                <!-- <Checkbox inputId="binary_Add_data" v-model="checkedBox_Add_data" :binary="true" v-else/> -->
                <Checkbox inputId="binary_Add_data" v-model="checkedBox_Add_data" value=true />
                <label for="binary_Add_data"> สิทธิ์เพิ่มข้อมูล</label>
              </div>
            </div>
            <!-- Edit data -->
            <div class="p-field p-col-12 p-lg-3 p-mt-3">
              <div class="field-checkbox">
              <!-- <Checkbox inputId="binary_Edit_data" v-model="checkedBox_Edit_data" :binary="false" v-if="checkedBox_Edit_data == false || checkedBox_Edit_data == 'false'"/> -->
              <!-- <Checkbox inputId="binary_Edit_data" v-model="checkedBox_Edit_data" :binary="true" v-else/> -->
              <Checkbox inputId="binary_Edit_data" v-model="checkedBox_Edit_data" value=true />
                <label for="binary_Edit_data"> สิทธิ์แก้ไขข้อมูล </label>
              </div>
            </div>
            <!-- Delete data -->
            <div class="p-field p-col-12 p-lg-3 p-mt-3">
              <div class="field-checkbox">
              <!-- <Checkbox inputId="binary_Delete_data" v-model="checkedBox_Delete_data" :binary="false"  v-if="checkedBox_Delete_data == false || checkedBox_Delete_data == 'false'"/> -->
              <!-- <Checkbox inputId="binary_Delete_data" v-model="checkedBox_Delete_data" :binary="true" v-else/> -->
              <Checkbox inputId="binary_Delete_data" v-model="checkedBox_Delete_data" value=true />  
              <label for="binary_Delete_data"> สิทธิ์ลบข้อมูล</label>
              </div>
            </div>
       
            <!-- จบส่วนจัดการข้อมูล -->
          </div>

          <div class="p-formgrid p-grid p-mt-5" style="display:flex;justify-content:flex-end;">
            <div class="p-field p-col-12 p-lg-3">
              <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                <InputText
                    id="date_create_form"
                    type="text"
                    v-model="date_create_form"
                    autofocus
                    disabled
                />
            </div>
            <div class="p-field p-col-12 p-lg-3">
              <label for="date_update_form">{{
                      $t("imp_update_info_date")
                    }}<span class="required-input"> </span></label>
                <InputText
                    id="date_update_form"
                    type="text"
                    v-model="date_update_form"
                    autofocus
                    disabled
                />
            </div>
          </div>

        </div>
      </div>
      <template #footer>
        <Button
          v-if="selectedData != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
          ref="TextBox_6"
          @keyup.left="moveFocus($event, isDisabledPassword !== 1 ? 'TextBox_5':'TextBox_4','Input')"
          @keyup.right="moveFocus($event, 'TextBox_7','Button')"
          @keyup.up="moveFocus($event, isDisabledPassword !== 1 ? 'TextBox_5' :'TextBox_4','Input')"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
          ref="TextBox_6"
          @keyup.left="moveFocus($event, isDisabledPassword !== 1 ? 'TextBox_5':'TextBox_4','Input')"
          @keyup.right="moveFocus($event, 'TextBox_7','Button')"
          @keyup.up="moveFocus($event, isDisabledPassword !== 1 ? 'TextBox_5' :'TextBox_4','Input')"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveData()"
          ref="TextBox_7"
          @keyup.left="moveFocus($event, 'TextBox_6','Button')"
          @keyup.right="moveFocus($event, 'TextBox_1','Button')"
          @keyup.up="moveFocus($event, isDisabledPassword !== 1 ? 'TextBox_5' :'TextBox_4','Input')"
        />
      </template>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete(temp)"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Are you sure for close this modal -->
    <Dialog
      :modal="true"
      :header="$t('ConfirmCloseModal')"
      :visible.sync="displayConfirmationCloseModal"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <span>{{ $t("ConfirmCloseModalSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmationCloseModal = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="closeAllModal()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import organizeTable from "../../Report/OrganizeMultiSelectTable.vue"
import organizeForm from "../OrganizeTableForm.vue";

import textFooter from "../../../mixins/textFooter_Search_html"

export default {
  name: "admin-user",
  components: {
    organizeTable,
    organizeForm,
    textFooter,
  },
  data() {
    return {
      dropdownClearFilerValue:0,
      // start checkbox
      checkedBox_View_data: ["true"],
      checkedBox_Add_data: [],
      checkedBox_Edit_data: [],
      checkedBox_Delete_data: [],
      // checkedBox_View_data: true,
      // checkedBox_Add_data: true,
      // checkedBox_Edit_data: true,
      // checkedBox_Delete_data: true,
      // end checkbox

      checkRole:null,
      checkView_data:null,
      checkAdd_data:null,
      checkEdit_data:null,
      checkDelete_data:null,

      organize: "",
      keyword: "",
      type: "text",
      selectedSystemUser: null,
      systemUser_table: [],
      filters: {},
      temp: null,
      showOrganize: false,
      selectedOrganize: {},
      displayConfirmation: false,
      permissionOptions: [],
      permissionSelect: null,
      header: this.$i18n.t("isu_modal_title_add"),
      selectedData: "",

      systemUserModal: false,
      isu_fullname: "",
      isu_organize: {},
      isu_username: "",
      isu_password: "",
      isu_password_generate: [],
      isDisabledPassword: 0,
      error_isu_fullname: false,
      error_isu_organize: false,
      error_isu_username: false,
      error_isu_password: false,
      error_isu_level_select: false,
      isu_level_select: null,
      disabledGenPassword: false,

      check_duplicate: "",
      displayConfirmationCloseModal: false,
      tempFor_displayConfirmationCloseModal: "",

      loading:false,

      showOrganize_Form:false,
      deleteTable:"",

      selectedOrganizeData: [],
      organize_table: [],
      parentmessage_organize: null,

      styleClassHeader:{
        divHead : this.checkPermission() ?"p-col p-mt-3 p-ml-3" :"p-grid p-col p-mt-3 p-ml-3",
        divBody : this.checkPermission() ?"p-field p-col-12 p-lg-12 p-mt-2" : "p-field p-col-12 p-lg-6 p-mt-2"
      },

      table_BOXmanege:window.innerWidth  > 700 ? 'p-field p-col' : '',
      table_editBTN:window.innerWidth > 700 ? this.$i18n.t('editBtn'):'',
      table_deleteBTN:window.innerWidth > 700 ? this.$i18n.t('deleteBtn'):'',

      table_headerStyle:this.checkInnerWidth('15rem','Column'),
      table_bodyStyle:this.checkInnerWidth('15rem','Body'),

      date_create_form:"",
      date_update_form:"",

      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"สังกัด",
          textShow:"",
        },
        {
          DataName:"ระดับสิทธิ์",
          textShow:"",
        },
        {
          DataName:"คำค้นหา",
          textShow:"",
        },
      ],
    };
  },
  watch: {
    isu_password_generate(val) {
      if (val.length == 1) {
        this.isu_password = this.generatePassword(6);
        this.isDisabledPassword = 1;
      } else {
        this.isu_password = "";
        this.type = "text";
        this.isDisabledPassword = 0;
      }
    },

    async systemUserModal(val) {
      if (val == false) {
        if (
          this.tempFor_displayConfirmationCloseModal == "" &&
          this.selectedData == "" &&
          this.isu_organize.name != undefined &&
          this.isu_fullname != "" &&
          this.isu_username != "" &&
          this.isu_password != "" &&
          this.isu_level_select != null
        ) {
          // this.displayConfirmationCloseModal = true;
          this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.systemUserModal = false;
                      this.clearData();
                      
                    }else{
                      this.systemUserModal = true;
                      
                    }
                  })
        } else {
          await this.axios
            .post(`${this.$url_service}/admin/permission`, {
              body: { topic: "get-option" },
            })
            .then((response) => {
              (this.permissionOptions = response.data.data),
                this.permissionOptions.splice(0, 0, {
                  permission_id: "getall",
                  permission_name: this.$i18n.t("selectAll"),
                });
            });
          this.clearData();
        }
      } else {
        await this.axios
          .post(`${this.$url_service}/admin/permission`, {
            body: { topic: "get-option" },
          })
          .then((response) => (this.permissionOptions = response.data.data));

          if (this.temp === null) {
            this.date_create_form = this.checkDate_showEN(new Date())
            this.date_update_form = this.checkDate_showEN(new Date())
          }
      }
    },

    displayConfirmationCloseModal(val) {
      if (val == true) {
        this.systemUserModal = true;
      }
    },

    // check_duplicate(val) {
    //   if (val == "duplicate") {
    //     // this.$toast.add({
    //     //   severity: "error",
    //     //   summary: "เพิ่มข้อมูลผู้ใช้งานระบบไม่สำเร็จ",
    //     //   detail: "มีข้อมูลผู้ใช้งานนี้ในระบบแล้ว",
    //     //   life: 3000,
    //     // });

    //     this.$fire({
    //           type: "error",
    //           title: "เพิ่มข้อมูลผู้ใช้งานระบบไม่สำเร็จ",
    //           text: "มีข้อมูลผู้ใช้งานนี้ในระบบแล้ว",
    //           timer: 3000,
    //           confirmButtonColor: '#28B463',
    //         });
    //   } else {
    //     // this.$toast.add({
    //     //   severity: "success",
    //     //   summary: "เพิ่มข้อมูลสำเร็จ",
    //     //   detail: "ข้อมูลผู้ใช้งานระบบ",
    //     //   life: 3000,
    //     // });
    //     this.$fire({
    //           type: "success",
    //           title: "เพิ่มข้อมูลสำเร็จ",
    //           text: "ข้อมูลผู้ใช้งานระบบ",
    //           timer: 3000,
    //           confirmButtonColor: '#28B463',
    //         });
    //   }
    // },

    selectedOrganize(val) {
      if (val != "") {
        this.showOrganize = false;
      }
    },

    isu_organize(val) {
      if (val != "") {
        this.showOrganize = false;
        // console.log(val);
      }
    },
    showOrganize(val) {
      if (val == true) {
        if (this.organize_table.length > 0) {
          this.parentmessage_organize = this.organize_table;
        } else {
          this.parentmessage_organize = [];
        }
      }
    },
  },
  created() {
    // console.log('d')
    window.addEventListener('resize', this.handleResize);
      this.handleResize();

    this.initialData();
    // checkbox
    // this.selectedCategories = this.categories.slice(1,3);
    // console.log('this.selectedCategorie =',this.selectedCategorie)
    // console.log('this.checkedBox_View_data =',this.checkedBox_View_data)
    // console.log('this.checkedBox_Add_data =',this.checkedBox_Add_data)
    // console.log('this.checkedBox_Edit_data =',this.checkedBox_Edit_data)
    // console.log('this.checkedBox_Delete_data =',this.checkedBox_Delete_data)


    this.checkRole = JSON.parse(localStorage.getItem("data")).permission_id;

    this.checkView_data = JSON.parse(localStorage.getItem("data")).view_data;
    this.checkAdd_data = JSON.parse(localStorage.getItem("data")).add_data;
    this.checkEdit_data = JSON.parse(localStorage.getItem("data")).edit_data;
    this.checkDelete_data = JSON.parse(localStorage.getItem("data")).delete_data;

    // console.log(`checkRole = ${this.checkRole} `);
    // console.log(`checkView_data = ${this.checkView_data} `);
    // console.log(`checkAdd_data = ${this.checkAdd_data} `);
    // console.log(`checkEdit_data = ${this.checkEdit_data} `);
    // console.log(`checkDelete_data = ${this.checkDelete_data} `);

    this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)

  },
  destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
  mounted() {},
  methods: {
    saveData_Modal(ModalName){
      if (ModalName === "search"){
        if (!this.isFocused("TextBox_1_search") &&
            !this.isFocused("TextBox_3_search") &&
            !this.isFocused("TextBox_4_search")) {
              this.searchSystemUser()
        }
        
      }else if( ModalName === "Modal_Main"){
        if (!this.isFocused("TextBox_1") &&
            !this.isFocused("TextBox_2") &&
            !this.isFocused("TextBox_6") &&
            !this.isFocused("TextBox_7")) {
            this.saveData()
        }
      }
    },
    handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : ''
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn'):''
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn'):''
            if (window.innerWidth > 700) {
              this.table_headerStyle = this.checkInnerWidth('15rem','Column')
              this.table_bodyStyle = this.checkInnerWidth('15rem','Body')
            }else{
              this.table_headerStyle = this.checkInnerWidth('105px','Column')
              this.table_bodyStyle = this.checkInnerWidth('105px','Body')
            }
    },

    async initialData() {
      this.filters={}
      this.loading = true;
      await this.axios
        .post(`${this.$url_service}/admin/user`, {
          body: {
            topic: "get-table",
            userOrg: this.checkPermission() ? null : this.getUserOrganize(),
            isDistrict: this.getUserOrganize() === 'or-000157' ? localStorage.getItem('username') : ''
          },
        })
        .then((response) => {
          this.systemUser_table = response.data.data
          this.formatData(this.systemUser_table)
        // console.log('get-table =',response.data.data);
        });
      await this.axios
        .post(`${this.$url_service}/admin/permission`, {
          body: {
            topic: "get-option",
          },
        })
        .then((response) => {
          (this.permissionOptions = response.data.data),
            this.permissionOptions.splice(0, 0, {
              permission_id: "getall",
              permission_name: this.$i18n.t("selectAll"),
            });
        });
        this.loading = false;
    },
    formatData(data){
      for (let index = 0; index < data.length; index++) {
          if (data[index].date_create_ddmmyy == null ||
              data[index].date_create_ddmmyy == "null" ||
              data[index].date_create_ddmmyy == "" ) {
            data[index].date_create_ddmmyy = "-";
          }else{
            data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy))
          }

          if (data[index].date_update_ddmmyy == null ||
              data[index].date_update_ddmmyy == "null" ||
              data[index].date_update_ddmmyy == "" ) {
            data[index].date_update_ddmmyy = "-";
          }else{
            data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy))
          }
        
      }
    },
    checkChar() {
      //Only English and number
      this.isu_username = this.isu_username.replace(
        /[^A-Za-z0-9!"#$%&'()*+,-./:;<=>?@_`{}~]/gi,
        ""
      );
      this.isu_password = this.isu_password.replace(
        /[^A-Za-z0-9!"#$%&'()*+,-./:;<=>?@_`{}~]/gi,
        ""
      );
    },

    closeAllModal() {
      this.systemUserModal = false;
      this.displayConfirmationCloseModal = false;
      this.clearData();
    },

    generatePassword(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },

    selectedOrganize_passValue_Form(variable) {
      this.showOrganize_Form = false;
      if (this.systemUserModal == false) {
        this.selectedOrganize = {
          id: variable.organize_id,
          name: variable.organize_name,
        };
      } else {
        this.isu_organize = {
          id: variable.organize_id,
          name: variable.organize_name,
        };
      }
    },

    selectedOrganize_passValue(variable) {
      this.showOrganize = false;
      if (variable != null) {
        this.organize_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.organize_table.push({
            organize_id: variable[i].organize_id,
            organize_name: variable[i].organize_name,
          });
        }
      }
    },

    async searchSystemUser() {
      this.loading = true;
      // this.filters={}
      // console.log('this.checkPermission()',this.checkPermission());
      // console.log('this.organize_table',this.organize_table);
      // console.log('this.getUserOrganize() =',this.getUserOrganize());
      await this.axios
        .post(`${this.$url_service}/admin/user`, {
          body: {
            topic: "search-table",
            keyword: this.keyword,
            level: this.permissionSelect,
            // organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
            organize: this.checkPermission() ? this.organize_table : this.getUserOrganize(),
            // organize: this.organize_table
            isDistrict: this.getUserOrganize() === 'or-000157' ? localStorage.getItem('username') : ''

          },
        })
        .then((response) =>{ (this.systemUser_table = response.data.data)
        this.formatData(this.systemUser_table)

        this.setSearchText_Footer()
        });
        this.loading = false;
    },
    setSearchText_Footer(){
      this.text_Footer=false;
          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.organize_table.length !== 0 ||
              this.permissionSelect !== null ||
              this.keyword !== ""){
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if (element.DataName === "สังกัด" && this.organize_table.length !== 0) {
                  element.textShow = this.setAll_organize_table(this.organize_table)
                }
                if (element.DataName === "ระดับสิทธิ์" && this.permissionSelect !== null ) {
                  element.textShow = this.permissionSelect.permission_name
                }
                if (element.DataName === "คำค้นหา" && this.keyword !== "" ) {
                  element.textShow = this.keyword
                }
              }
              this.text_Footer=true;
          }
    },
    setAll_organize_table(data){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element.organize_name !== undefined) {
          text += element.organize_name + ",";
        }
      }
      return text.slice(0, -1)
    },

    async confirmDelete() {
      if (this.deleteTable == "organize") {
          this.displayConfirmation = false;
          this.organize_table = this.organize_table.filter(
            (val) => val !== this.organizeDelete
          );
      }else{
        this.displayConfirmation = false;
        await this.axios
          .post(`${this.$url_service}/admin/user?user=${this.getUsername()}`, {
            body: {
              topic: "delete-user",
              id: this.temp,
            },
          })
          .then(() => 
          // this.initialData()
          this.searchSystemUser()
          );
        // this.$toast.add({
        //   severity: "success",
        //   summary: "ลบข้อมูลสำเร็จ",
        //   detail: "ข้อมูลผู้ใช้งานระบบ",
        //   life: 3000,
        // });
        this.$fire({
                type: "success",
                title: "ลบข้อมูลสำเร็จ",
                text:  "ข้อมูลผู้ใช้งานระบบ",
                timer: 3000,
                confirmButtonColor: '#28B463',
              });
      }
      
    },

    async saveData() {
      //Check null value
      if (
        this.isu_organize.name == undefined ||
        this.isu_fullname == "" ||
        this.isu_username == "" ||
        this.isu_password == "" ||
        this.isu_level_select == null
      ) {
        if (this.isu_organize.name == undefined) {
          this.error_isu_organize = true;
        }
        if (this.isu_fullname == "") {
          this.error_isu_fullname = true;
        }
        if (this.isu_username == "") {
          this.error_isu_username = true;
        }
        if (this.isu_password == "") {
          this.error_isu_password = true;
        }
        if (this.isu_level_select == null) {
          this.error_isu_level_select = true;
        }
      } else {
        if (this.selectedData == "") {
          await this.axios
            .post(
              `${this.$url_service}/admin/user?user=${this.getUsername()}`,
              {
                body: {
                  topic: "add-user",
                  organize_id: this.isu_organize.id,
                  fullname: this.isu_fullname,
                  username: this.isu_username,
                  password: this.isu_password,
                  permission_id: this.isu_level_select.permission_id,
                  view_data :this.checkedBox_View_data[0] == "true" ? true : this.checkedBox_View_data == false,
                  add_data :this.checkedBox_Add_data[0] == "true" ? true : this.checkedBox_View_data == false,
                  edit_data :this.checkedBox_Edit_data[0] =="true" ? true : this.checkedBox_View_data == false,
                  delete_data :this.checkedBox_Delete_data[0] == "true" ? true : this.checkedBox_View_data == false,

                },
              }
            )
            .then((response) => {
              (this.check_duplicate = response.data.message),
                // this.initialData();
                this.searchSystemUser()

                // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                // console.log("this.check_duplicate ",this.check_duplicate)
                if(this.check_duplicate == "duplicate" ){
                  
                  this.$fire({
                    type: "error",
                    title:"เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ",
                    text: "มีข้อมูลนี้ในระบบแล้ว",
                    timer: 3000,
                    confirmButtonColor: '#d33',
                  });
                }else{
                  this.$fire({
                        title: "เพิ่มข้อมูลสำเร็จ",
                        text: "ข้อมูลผู้ใช้งานระบบ",
                        type: "success",
                        timer: 3000,
                        confirmButtonColor: '#28B463',
                      });
                }
               

                // console.log('add-user this.checkedBox_View_data =',this.checkedBox_View_data[0] == "true" ? true : this.checkedBox_View_data == false)
                // console.log('add-user this.checkedBox_Add_data =',this.checkedBox_Add_data[0] == "true" ? true : this.checkedBox_View_data == false)
                // console.log('add-user this.checkedBox_Edit_data =',this.checkedBox_Edit_data[0] =="true" ? true : this.checkedBox_View_data == false)
                // console.log('add-user this.checkedBox_Delete_data =',this.checkedBox_Delete_data[0] == "true" ? true : this.checkedBox_View_data == false)
            });
          this.systemUserModal = false;
          this.tempFor_displayConfirmationCloseModal = "add";
        } else {

          // console.log('edit-user this.checkedBox_View_data =',this.checkedBox_View_data)
          //       console.log('edit-user this.checkedBox_Add_data =',this.checkedBox_Add_data)
          //       console.log('edit-user this.checkedBox_Edit_data =',this.checkedBox_Edit_data)
          //       console.log('edit-user this.checkedBox_Delete_data =',this.checkedBox_Delete_data)

          this.systemUserModal = false;
          await this.axios
            .post(
              `${this.$url_service}/admin/user?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-user",
                  id: this.temp,
                  organize_id: this.isu_organize.id,
                  fullname: this.isu_fullname,
                  username: this.isu_username,
                  password: this.isu_password,
                  permission_id: this.isu_level_select.permission_id,
                  view_data :this.checkedBox_View_data[0] == "true" ? true : this.checkedBox_View_data == false,
                  add_data :this.checkedBox_Add_data[0] == "true" ? true : this.checkedBox_View_data == false,
                  edit_data :this.checkedBox_Edit_data[0] =="true" ? true : this.checkedBox_View_data == false,
                  delete_data :this.checkedBox_Delete_data[0] == "true" ? true : this.checkedBox_View_data == false,
                },
              }
            )
            .then(() => 
            // this.initialData()
            this.searchSystemUser()
            );
          // this.$toast.add({
          //   severity: "success",
          //   summary: "แก้ไขข้อมูลสำเร็จ",
          //   detail: "ข้อมูลผู้ใช้งานระบบ",
          //   life: 3000,
          // });
          this.$fire({
              type: "success",
              title: "แก้ไขข้อมูลสำเร็จ",
              text: "ข้อมูลผู้ใช้งานระบบ",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
        }
      }
    },

    async editData(data) {
      this.header = this.$i18n.t("isu_modal_title_edit");
      this.disabledGenPassword = true;
      this.type = "password";
      this.isDisabledPassword = 1;
      await this.axios
        .post(`${this.$url_service}/admin/user`, {
          body: {
            topic: "showone-user",
            id: data,
          },
        })
        .then((response) => {
          // console.log(response.data.data),
            (this.selectedData = response.data.data),
            (this.isu_organize = {
              id: response.data.data.user_organize,
              name: response.data.data.organize_name,
            }),
            (this.isu_fullname = response.data.data.user_fullname),
            (this.isu_username = response.data.data.user_username),
            (this.isu_password = response.data.data.user_password),
            (this.isu_level_select = {
              permission_id: response.data.data.permission_id,
              permission_name: response.data.data.permission_name,
            })
            ,(this.checkedBox_View_data = response.data.data.view_data == 'false' ? [] : [response.data.data.view_data]),
            (this.checkedBox_Add_data = response.data.data.add_data == 'false' ? [] :[response.data.data.add_data]),
            (this.checkedBox_Edit_data = response.data.data.edit_data == 'false' ? [] :[response.data.data.edit_data]),
            (this.checkedBox_Delete_data = response.data.data.delete_data == 'false' ? [] :[response.data.data.delete_data])
            // ,
            // console.log('checkedBox_View_data =',this.checkedBox_View_data),
            // console.log('checkedBox_Add_data = ',this.checkedBox_Add_data),
            // console.log('checkedBox_Edit_data = ',this.checkedBox_Edit_data),
            // console.log('checkedBox_Delete_data = ',this.checkedBox_Delete_data)

            // console.log('add-user this.checkedBox_View_data =',this.checkedBox_View_data[0] == "true" ? true : this.checkedBox_View_data == false)
            //     console.log('add-user this.checkedBox_Add_data =',this.checkedBox_Add_data[0] == "true" ? true : this.checkedBox_View_data == false)
            //     console.log('add-user this.checkedBox_Edit_data =',this.checkedBox_Edit_data[0] =="true" ? true : this.checkedBox_View_data == false)
            //     console.log('add-user this.checkedBox_Delete_data =',this.checkedBox_Delete_data[0] == "true" ? true : this.checkedBox_View_data == false)

            
            // (
            //   checkedBox_View_data = true
            //   checkedBox_Add_data = true
            //   checkedBox_Edit_data = true
            //   checkedBox_Delete_data = true
            // ),

            this.date_create_form = response.data.data.date_create_ddmmyy == null ? "-" : response.data.data.date_create_ddmmyy
            this.date_update_form = response.data.data.date_update_ddmmyy == null ? "-" : response.data.data.date_update_ddmmyy
            
        });
    },

    clearData() {
      this.dropdownClearFilerValue +=1;
      //Edit data
      if (this.selectedData != "") {
        this.header = this.$i18n.t("isu_modal_title_add");
        this.temp = null;
        this.displayConfirmation = false;
        this.systemUserModal = false;
        this.type = "text";
        this.selectedData = "";
        this.setDefault();
        //Add data
      } else {
        this.temp = null;
        this.displayConfirmation = false;
        this.setDefault();
      }
    },

    setDefault() {
      this.tempFor_displayConfirmationCloseModal = "";
      this.isu_fullname = "";
      this.isu_organize = "";
      this.isu_username = "";
      this.isu_password = "";
      this.reset_password = false;
      this.isu_password_generate = "";
      this.error_isu_fullname = false;
      this.error_isu_organize = false;
      this.error_isu_username = false;
      this.error_isu_password = false;
      this.error_isu_level_select = false;
      this.isu_level_select = null;

      // ล้างรหัสผ่าน * ในกรณีไปกดแก้ไขแล้วกดเพิ่มต้องให้เหมือนเริ่มต้น
      this.disabledGenPassword = false;
      this.isDisabledPassword = 0; //0 กรอกได้ 1 กรอกไม่ได้
      // ให้ค่าเริ่มต้นปุ่มคือ ติ๊กหมด
      this.checkedBox_View_data = ["true"];
      this.checkedBox_Add_data = [];
      this.checkedBox_Edit_data = [];
      this.checkedBox_Delete_data = [];

      this.date_create_form = ""
      this.date_update_form = ""
    },

    async clearSearchField() {
      this.dropdownClearFilerValue +=1;
      this.organize_table= [];
      this.selectedOrganize = {};
      this.permissionSelect = null;

      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;

      this.keyword = "";
      this.filters={}
      this.initialData()
    },
    alertDisplay(temp,deleteTable) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log(temp)
                      this.confirmDelete(temp,deleteTable)
                    }
                  })
    },
  },
};
</script>

<style scoped>

.table_row{
  text-align: center;
}

@media screen and (min-width: 538px) and (max-width: 1200px)  {
  #Search{
      width: 21rem;
    }
}
@media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
}

@media screen and (max-width: 430px) {
 
  .EV_disasterOptions{
  width: 16.75rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>


<!--  -->
<style scoped lang="scss">

:deep(.p-datatable-wrapper table){
  border-left: 1px solid #d6d4d4;
  border-right: 1px solid #d6d4d4;
  border-collapse: separate;
  border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper){
    max-height: 550px;
    overflow: auto;
}

:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
      .p-dialog-content{
        overflow-y: auto;
      }
    }
    
  }
.customer-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.status-true {
		background: #C8E6C9;
		color: #256029;
	}

	&.status-false {
		background: #FFCDD2;
		color: #C63737;
	}
}

</style>